module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "flat": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("\n      Share a form\n    ")], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('form-list', {
    attrs: {
      "relationship-id": _vm.relationshipId
    },
    on: {
      "selected": _vm.setSelectedForm
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "420",
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.showShare),
      callback: function($$v) {
        _vm.showShare = $$v
      },
      expression: "showShare"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showShare = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.links && _vm.links.length > 0) ? _c('share-card', {
    attrs: {
      "links": _vm.links
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1743c44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/forms/ShareForm.vue
// module id = 1503
// module chunks = 9